import * as React from "react";

import "./LinePicker.css";
import { Popover } from "reactstrap";
import { Checkbox } from "./Checkbox";
import { ILine, LineID } from "src/api/APIClient";
import { RootState } from "src/types";
import { connect } from "react-redux";
import { fetchLines } from "src/thunks";

interface IProps {
  checked?: LineID[];
  indeterminate?: LineID[];

  autoFocus?: boolean;
  allowCreate?: boolean;

  onCreate?: (id: LineID) => any;
  onSelect?: (id: LineID) => any;

  target: string | HTMLElement;
  isOpen: boolean;
  toggle?: () => any;

  lines: ILine[];
  fetchLines: () => any;
}

interface IRow {
  line: ILine;
  checked: boolean;
  indeterminate: boolean;
}

interface IState {
  filter: string;
}

export class LinePicker extends React.Component<IProps, IState> {
  public state: IState = {
    filter: "",
  };

  public componentDidMount() {
    this.props.fetchLines();
  }

  public componentWillUpdate(props: IProps) {
    if (props.isOpen && !this.props.isOpen) {
      this.props.fetchLines();
    }
  }

  public render() {
    const {
      target,
      lines,
      isOpen,
      toggle,
      allowCreate,
      autoFocus,
    } = this.props;
    const { filter } = this.state;

    // PERF: move filtering out of render for better perf
    const rows = this.calcRows();

    const filterMatches = !!lines.find(l => l.id === filter);

    return (
      <div className="line-picker">
        <Popover
          placement="bottom"
          target={target}
          toggle={toggle}
          isOpen={isOpen}
        >
          <div className="line-picker-body">
            <label className="line-filter-label" htmlFor="line-filter">
              Set lines:
            </label>
            <input
              id="line-filter"
              className="line-filter"
              value={filter}
              onChange={this.onFilterChange}
              autoFocus={!!autoFocus}
              type="text"
            />
            <div className="line-list">
              {rows.length > 0 ? (
                rows.map(this.renderRow)
              ) : (
                <div className="line-row">
                  <span>No Results</span>
                </div>
              )}
            </div>
            {allowCreate ? (
              <button
                onClick={this.onClickCreate}
                style={{
                  display: filterMatches || filter === "" ? "none" : undefined,
                }}
                className="apply-button"
              >
                "<b>{filter}</b>" (create new)
              </button>
            ) : null}
          </div>
        </Popover>
      </div>
    );
  }

  private calcRows() {
    const { lines, checked, indeterminate } = this.props;
    const { filter } = this.state;

    let rows = lines
      // apply the filter
      .filter(line => line.id.startsWith(filter))
      // calculate the row properties
      .map(line => {
        return {
          line,
          checked: checked ? checked.indexOf(line.id) >= 0 : false,
          indeterminate: indeterminate
            ? indeterminate.indexOf(line.id) >= 0
            : false,
        };
      });

    // sort by state then id
    rows = rows.sort((a, b) => {
      if (a.checked && !b.checked) {
        return -1;
      } else if (b.checked && !a.checked) {
        return 1;
      }

      if (a.indeterminate && !b.indeterminate) {
        return -1;
      } else if (b.indeterminate && !a.indeterminate) {
        return 1;
      }

      const idA = a.line.id;
      const idB = b.line.id;

      return idA.localeCompare(idB);
    });

    return rows;
  }

  private renderRow = (row: IRow) => {
    const { indeterminate, checked, line } = row;

    return (
      <div
        key={line.id}
        data-id={line.id}
        onClick={this.onClickRow}
        className="line-row"
      >
        <Checkbox indeterminate={indeterminate} checked={checked} />
        <span>{line.id}</span>
      </div>
    );
  };

  private onFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({
      filter: value.toLocaleLowerCase(),
    });
  };

  private onClickCreate = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    const { onCreate } = this.props;
    const { filter } = this.state;

    if (onCreate) {
      onCreate(filter as LineID);
    }
  };

  private onClickRow = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    const { onSelect } = this.props;

    const div = e.currentTarget;
    const id = div.dataset.id as LineID;

    if (onSelect) {
      onSelect(id);
    }
  };
}

export const LinePickerContainer = connect(
  ({ lines }: RootState) => ({
    lines: lines.data,
  }),
  dispatch => ({
    fetchLines: () => dispatch<any>(fetchLines()),
  })
)(LinePicker);

export default LinePickerContainer;



// WEBPACK FOOTER //
// ./src/components/LinePicker.tsx